<template>
    <div class="p-home">
        <header>
            <!-- Fixed navbar -->
            <nav class="navbar navbar-expand-md navbar-white bg-white">
                <main role="main" class="container">
                    <a href="http://penizeproprahu.cz/"><img :src="`${publicPath}assets/images/logo_oppr-praha.jpg`" alt="" title="" class="logos"></a>
                    <a href="http://www.fel.cvut.cz/cz/"><img :src="`${publicPath}assets/images/logo_FEL.jpg`" alt="" title="" class="logos"></a>
                    <pageTitle :title="translate('Login.login')"></pageTitle>
                </main>
            </nav>
        </header>
        <!-- Begin page content -->
        <main role="main" class="container">
            <h1 id="operator" class="mt-3 mb-3">{{ translate('Home.operator') }}</h1>
            <h2 id="platformPurpose" class="mb-4">{{ translate('Home.desc1') }}</h2>
            <router-link to="/rozcestnik">
                <img class="mx-auto d-block main_img" :src="`${publicPath}assets/images/dual_monitor.png`" alt="">

            </router-link>
            <p id="platformDescription" class="lead py-4">{{ translate('Home.desc2') }}</p>
            <div class="col text-center">
                <router-link to="/rozcestnik">
                    <div id="enterApplication" class="btn-get-started scrollto">{{ translate('Home.playOperator') }}</div>
                </router-link>
            </div>
        </main>
        <footer class="footer">
            <div class="container">
                <span class="text-muted"><a href="mailto:operatorZOS@fel.cvut.cz" class="bottlink">operatorZOS@fel.cvut.cz</a> | <a id="department" href="http://comtel.fel.cvut.cz/" class="bottlink">{{ translate('Home.department') }}</a> | <a id="faculty" href="http://fel.cvut.cz/cz/" class="bottlink">{{ translate('Home.faculty') }}</a> | <a id="cvutPrague" href="http://cvut.cz/" class="bottlink">{{ translate('Home.location') }}</a> | © 2019</span>
            </div>
        </footer>
    </div>
</template>

<script>
import pageTitle from "../components/pageTitle";


export default {
    name: 'home',
    components: {
        pageTitle
    },
    data () {
      return {
          publicPath: process.env.BASE_URL
      }
    }
}

</script>

<style lang="css" scoped>
    .p-home {
        position: relative;
        padding-bottom: 60px;
    }

</style>
